import { type ReactNode } from 'react';
import { COUNTRIES } from '@/utils/countries';
import { Input } from '@/components/ui/input';
import { Select } from '@/components/ui/select';
import type { PersonalForm } from './approacher-edit-personal-parts';

type Props = {
  f: PersonalForm;
  set: (k: keyof PersonalForm, v: string) => void;
};

export function PhoneRow({ f, set }: Props): ReactNode {
  return (
    <div className="col-span-2 grid grid-cols-[120px_1fr] gap-sm">
      <Select
        label="Prefijo"
        value={f.phone_prefix}
        onChange={(e) => set('phone_prefix', e.target.value)}
      >
        <option value="">—</option>
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.dialCode}>
            {c.dialCode} ({c.code})
          </option>
        ))}
      </Select>
      <Input
        type="tel"
        label="Telefono"
        value={f.phone_number}
        onChange={(e) => set('phone_number', e.target.value)}
      />
    </div>
  );
}

export function LocationRow({ f, set }: Props): ReactNode {
  return (
    <>
      <Select
        label="Pais"
        value={f.country}
        onChange={(e) => set('country', e.target.value)}
      >
        <option value="">—</option>
        {COUNTRIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.name}
          </option>
        ))}
      </Select>
      <Input
        label="Ciudad"
        value={f.city}
        onChange={(e) => set('city', e.target.value)}
      />
    </>
  );
}
